import { apiHost } from '../../../config';
import { deleteRequest } from '../../requests';

export default async function deleteMunicipality(id: number) {
  return deleteRequest(`${apiHost}/api/admin/municipalities/${id}`);
}
